/** @format */

export default {
  data() {
    return {
      documentData: [],
    };
  },
  computed: {},
  methods: {
    async getDocumentPayments(data) {
      let res = [];
      let resp = await this.$axios.post('/report_sql', { name: 'planning_getDocumentPayments', params: { id: data.id } });
      if (resp.data.status == 'ok') {
        res = resp.data.data;
      }
      this.documentData = res;
      return res;
    },
    async getObjectProgress(id = 0) {
      let res = [];

      let resp = await this.$axios.post('/report_sql', { name: 'planning_getObjectProgress', params: { id: id || -1 } });
      if (resp.data.status == 'ok') {
        res = resp.data.data;
      }
      return res;
    },
    async getObjectBalance(data) {
      let res = [];
      let accIds = [];
      let resp = await this.$axios.post('/report_sql', { name: 'getAccRecordsForPlanning', params: { id: data.id } });
      if (resp.data.status == 'ok') {
        accIds = resp.data.data.map((m) => {
          return m.id;
        });
      }
      accIds.push(-1);
      let params = {
        pager: {},
      };
      params.filters = { id: accIds };

      //resp = await this.$axios.post('/report_sql', { name: 'getAccRecordsForPlanningFull', params: { id: data.id } });
      resp = await this.$axios.get('accounting/records', { params });
      if (resp.data.status == 'ok') {
        res = resp.data.data;
      }
      return res;
    },
    calcBalance(data, balance, documents) {
      const type = (el, d) => {
        return [...(el.type || []), ...d];
      };
      let calc = {};
      let calc2 = {};
      calc['type_20'] = 0; //остаток средст инвестора
      calc['type_90'] = 0; //Средства компании
      calc['type_-1'] = 0; //незавершенные платежи
      let depts = [];
      for (let i = 0; i < balance.length; i++) {
        const el = balance[i];
        if (el.type) {
          /*      Object.defineProperty(this.balanceCalc, el.type, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: el.value,
          });
          // this.balanceCalc[el.type] = (this.balanceCalc[el.type] || 0) + el.value;
      */ continue;
        }
        el.type = null;
        /*
100 - первоначальный взнос - не зависимо от того кто его сделал
22 - первоначальный взнос - сделанный компанией
24 - первоначальный взнос - сделанный инвестором
20 - деньги наличка остаток
90 - деньги добавленные компанией
70 - все затраты инвестора или клиента
1 - стоимость реализации
2 - наличные вложения инвестора (без первоначального взноса)
3 - расходы организационные
4 - расходы административные
21 - Взнос инвестора, ипотека
23 - сумма выплаченных процентов по ипотеке
*/
        if ([11].includes(el.operation_id)) {
          if ([1, 15].includes(parseInt(el.debit_subconto_value_3))) {
            //затраты на оформление
            el.type = type(el, [3]);
            calc['type_20'] -= el.value;
          } else if ([49].includes(parseInt(el.debit_subconto_value_2))) {
            //затраты на оформление
            el.type = type(el, [3]);
            calc['type_20'] -= el.value;
          } else if ([24].includes(parseInt(el.debit_subconto_value_3))) {
            //покупка объекта (считаю что перв взнос из кассы компании) ---не кредит???
            el.type = type(el, [22, 100]);
          } else if ([21].includes(parseInt(el.debit_subconto_value_2))) {
            //в заказе услуг разнесенные административные расходв
            el.type = type(el, [4]);
            calc['type_20'] -= el.value;
          } else {
            el.type = type(el, [1]);
            calc['type_20'] -= el.value;
          }
        } else if ([1, 2, 46, 24].includes(el.operation_id)) {
          //затраты на реализацию
          el.type = type(el, [1]);
          calc['type_20'] -= el.value;
        } else if ([54].includes(el.operation_id)) {
          //распределение расходов
          el.type = type(el, [4]);
          calc['type_20'] -= el.value;
        } else if ([25].includes(el.operation_id)) {
          //снятие с резерва
          el.type = type(el, [1]);
          calc['type_20'] += el.value; //возвращаем средства в казну
          el.value = -el.value;
          //calc['type_1'] -= el.value; //минусуем стоимость реализации
        }

        //Долги по документам
        if ([1, 2, 11].includes(el.operation_id)) {
          let dept =
            this.documentData.find((d) => {
              return d.base_name == el.base_name && d.id == el.base_id;
            })?.value_dept || 0;
          if (dept) {
            if (!depts.includes(el.base_name + '#' + el.base_id)) {
              depts.push(el.base_name + '#' + el.base_id);
              calc['type_1'] -= dept; //минусуем стоимость реализации
              calc['type_20'] += dept; //возвращаем средства в казну
              calc['type_-1'] += dept; //возвращаем средства в казну
            }
            el.type = type(el, [-1]);
          }
        }

        if ([49, 48, 51].includes(el.operation_id)) {
          if (balance.find((b) => b.operation_id == 48)) {
            //Первоначальный взнос инвестор
            el.type = type(el, [24, 100, 70]);
          } else {
            //Первоначальный взнос компанией
            el.type = type(el, [22, 100]);
          }
        }
        if ([39, 43].includes(el.operation_id)) el.type = type(el, [23, 70]);
        if ([39].includes(el.operation_id)) calc['type_20'] -= el.value;

        if ([40].includes(el.operation_id)) el.type = type(el, [0]);

        //Возврат клиенту и инвестору
        if ([71, 72].includes(el.operation_id)) {
          el.type = type(el, [2, 70]);
          el.value = -el.value;
          calc['type_20'] += el.value;
        }

        //Общая себестоимость
        if ([1, 2, 11, 46, 36, 38, 49, 39, 43].includes(el.operation_id)) el.type = type(el, [9]);
        //Взнос инвестора наличка
        if ([44].includes(el.operation_id)) el.type = type(el, [70, 744]);
        if ([41].includes(el.operation_id)) el.type = type(el, [744]);
        if ([9, 27, 28, 29, 100, -48, 62].includes(el.operation_id)) el.type = type(el, [2, 70]);
        if ([9, 27, 28, 29, 100, 62].includes(el.operation_id)) calc['type_20'] += el.value;
        //Взнос инвестора ипотека
        if ([35, 38].includes(el.operation_id)) el.type = type(el, [21]);
        if ([38].includes(el.operation_id)) el.type = type(el, [70]);
        if (el.type) {
          el.type.forEach((t) => {
            if (!['-1', -1].includes(t)) {
              let val = calc?.['type_' + t] || 0;
              val = parseFloat(val.toFixed(2)) + el.value;
              calc['type_' + t] = val;
            }
          });
        } else {
          //группирую все неучтенные расходы по операции
          let val = calc2?.[el.operation_id] || 0;
          val = parseFloat(val.toFixed(2)) + el.value;
          calc2[el.operation_id] = val;
        }
      }
      calc.type_90 = calc.type_20 < 0 ? -calc.type_20 : 0;
      calc.type_20 = calc.type_20 > 0 ? calc.type_20 : 0;
      //console.log('ddddddd', { calc, calc2 });
      return { calc, calc2 };
    },
  },
};
